import { render, staticRenderFns } from "./CustomAddressChild.vue?vue&type=template&id=c09f6716&scoped=true&lang=html&"
import script from "./CustomAddressChild.vue?vue&type=script&lang=js&"
export * from "./CustomAddressChild.vue?vue&type=script&lang=js&"
import style0 from "./CustomAddressChild.vue?vue&type=style&index=0&id=c09f6716&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09f6716",
  null
  
)

export default component.exports